// extracted by mini-css-extract-plugin
export default {"container":"styles_container__S4szC","footnote":"styles_footnote__Unlsx","grayText":"styles_grayText__JeDoI"};